import { createRouter, createWebHistory } from 'vue-router'
import auth from "../services/auth";
import Login from '../views/Authentication/Login.vue'
import Forgot from '../views/Authentication/Forgot.vue'
import ChangesPass from '../views/Authentication/ChangesPass.vue'
import Profile from '../views/Authentication/Profile.vue'
import VerifyOTP from '../views/Authentication/VerifyOTP.vue'
import ResetPass from '../views/Authentication/ResetPass.vue'
import Dashboard2 from '../views/Dashboard2.vue'
import UserManagement from '../views/UserManagement.vue'
import UserRequest from '../views/UserRequest.vue'
import Parking from '../views/Parking.vue'
import Request from '../views/Request.vue'
import Content from '../views/Content.vue'
import Addcontent from '../views/Addcontent.vue'
import Notification from '../views/Notification.vue'
import Payment from '../views/Payment.vue'
import Support from '../views/Support.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: Forgot
  },
  {
    path: '/verifyotp',
    name: 'VerifyOTP',
    component: VerifyOTP
  },
  {
    path: '/resetpassword',
    name: 'ResetPass',
    component: ResetPass
  },
  {
    path: '/changepass',
    name: 'ChangesPass',
    component: ChangesPass,
    beforeEnter: auth
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter: auth
  },
  {
    path: '/dashboard',
    name: 'Dashboard2',
    component: Dashboard2,
    beforeEnter: auth
  },
  {
    path: '/requested_users',
    name: 'UserRequest',
    component: UserRequest,
    beforeEnter: auth
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    beforeEnter: auth
  },
  {
    path: '/parking',
    name: 'Parking',
    component: Parking,
    beforeEnter: auth
  },
  {
    path: '/request',
    name: 'Request',
    component: Request,
    beforeEnter: auth
  },
  {
    path: '/content',
    name: 'Content',
    component: Content,
    beforeEnter: auth
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
  },
  {
    path: '/addcontent',
    name: 'Addcontent',
    component: Addcontent,
    beforeEnter: auth
  },
  {
    path: '/notification',
    name: 'Notification',
    component: Notification,
    beforeEnter: auth
  },
  {
    path: '/payment_history',
    name: 'Payment',
    component: Payment,
    beforeEnter: auth
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
